import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { NoAuditor, NoAuditorForm } from "./noAuditorDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<NoAuditor>,
): NoAuditorForm {
  return new NoAuditorForm(context);
}

export function handleEvent() {}

export function isValid(form: NoAuditorForm): boolean {
  return form.allCompaniesHaveAuditor;
}

export function validate(form: NoAuditorForm): boolean {
  return isValid(form);
}

export function applyForm(): NoAuditor {
  return {
    type: DecisionType.noAuditor,
  };
}

export const noAuditorHandler: DecisionTypeHandler<
  DecisionType.noAuditor,
  NoAuditor,
  NoAuditorForm
> = {
  type: DecisionType.noAuditor,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
